import axios from './axios'
import {setAuth, getAuth, removeAuth} from '../modules/auth/core/AuthHelpers'
import {UserModel} from '../modules/auth'
import jwtDecode from 'jwt-decode'

const useRefreshToken = () => {
  const refresh = async () => {
    let res

    try {
      const user: UserModel = jwtDecode(getAuth()?.data.access_token!)
      res = await axios({
        method: 'POST',
        url: `/cms/auth/refresh-token`,
        data: {
          username: user.username,
          refresh_token: getAuth()?.data.refresh_token,
        },
      })
    } catch (error) {
      console.error(error)
      removeAuth()
      return null
    }
    const currentAuth = getAuth()
    if (res && currentAuth) {
      currentAuth.data.access_token = res.data.access_token
      setAuth(currentAuth)
    }
    return res.data.access_token
  }

  return refresh
}

export default useRefreshToken
